module.exports = __webpack_public_path__ + "img/product25-zhunong.02a73dfc.svg";